import { useEffect, useState } from 'react';
import { Box, Collapse } from '@mui/material';

import MenuOption from './MenuOption';
import SideMenuItem from './SideMenuItem';
import { useLocation } from 'react-router';
import SideMenuList from './SideMenuList';

interface Props {
  menuItem: MenuOption;
  parentIndex: number;
  child: Boolean;
}

function SideMenuItemContainer({ menuItem, parentIndex, child }: Props) {
  const [open, setOpen] = useState(true);
  const location = useLocation();

  const expandChildren = () => {
    setOpen(!open);
  };

  useEffect(() => {
    if (menuItem.children && menuItem.children.length > 0) {
      for (let index = 0; index < menuItem.children.length; index++) {
        const child = menuItem.children[index];
        if (location.pathname === child.route) {
          setOpen(true);
        }
      }
    }
  }, [menuItem.children, location.pathname]);

  return (
    <Box>
      <SideMenuItem
        keyName={menuItem.name + parentIndex}
        menuItem={menuItem}
        showChildren={() => expandChildren()}
        child={child}
      />
      {menuItem.children && menuItem.children.length > 0 && (
        <Collapse in={open} timeout="auto" unmountOnExit>
          <SideMenuList items={menuItem.children} childList={true} />
        </Collapse>
      )}
    </Box>
  );
}

export default SideMenuItemContainer;
